import React, { Component } from 'react';
import SideMenu from '../sidemenu/index';
import { withRouter } from 'react-router-dom';
import { isNonEmptyList } from '../../actions/validator';
import Footer from './footer';
import Header from './header';

/**
 * Props
 * ===============
 *      showLoader:       T/F depend upon loading page
 *      PageActions:      Right-Side Tab Details of current page AKA actions
 *      tabs:             Left-Side Tab Details of current page
 */
class Container extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isGettingData: false,
      showLoader: this.props.showLoader,
      PageActions: this.props.PageActions,
      selectedTab: '',
      tabs: this.props.tabs,
      content: null
    };

    this.update_container_content = this.update_container_content.bind(this);
    this.onTabClick = this.onTabClick.bind(this);
    this.__render_tabs = this.__render_tabs.bind(this);
  }

  componentDidMount() {
    this.update_container_content();
  }

  update_container_content() {
    if (isNonEmptyList(this.state.tabs)) {
      this.setState({
        selectedTab: this.state.tabs[0]['__name'],
        content: this.state.tabs[0]['__component']
      });
    } else {
      this.setState({
        content: this.props.children
      });
    }
  }

  componentWillReceiveProps(newProps) {
    var { showLoader, PageActions, tabs } = newProps;
    this.setState({ showLoader, PageActions, tabs }, () => {
      this.update_container_content();
    });
  }

  onTabClick(tab) {
    var isGettingData = true;
    this.setState({ isGettingData });

    var selectedTab = this.state.selectedTab;
    var content = this.state.content;

    this.state.tabs.map((T, idx) => {
      if (T['__name'] === tab['__name']) {
        selectedTab = T['__name'];
        content = T['__component'];
      }
      return T;
    });

    this.setState({ selectedTab, content });
  }

  __render_tabs() {
    var __html = [];
    if (isNonEmptyList(this.state.tabs)) {
      __html.push(
        <ul key={'tabs'} className="nav navbar-nav">
          {this.state.tabs.map((T, idx) => {
            if (T.__render === true) {
              const isSelected = this.state.selectedTab.toLowerCase() === T.__name.toLowerCase();
              return (
                <li
                  key={idx}
                  className="nav-item cursor-pointer"
                  onClick={this.onTabClick.bind(this, T)}
                >
                  <button
                    className={isSelected ? 'navbar-nav-link button-link active' : 'navbar-nav-link button-link'}
                    data-toggle="tab"
                    style={{
                      fontSize: '13px',
                      fontWeight: isSelected ? '600' : '500',
                      padding: '8px 16px',
                      borderRadius: '8px',
                      border: 'none',
                      background: isSelected ? '#EEF2FF' : 'transparent',
                      color: isSelected ? '#4338CA' : '#475569',
                      cursor: 'pointer',
                      transition: 'all 150ms ease',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '6px'
                    }}
                  >
                    <i className={T.__className} style={{ fontSize: '13px' }}></i>
                    {T.__name}
                  </button>
                </li>
              );
            }
            return '';
          })}
        </ul>
      );
    }

    if (isNonEmptyList(this.state.PageActions)) {
      __html.push(
        <ul key="actions" className="navbar-nav ml-lg-auto">
          {this.state.PageActions.map((PA, idx) => {
            if (PA.__render === true) {
              var uriDic = PA.__uri_extra;
              uriDic['pathname'] = PA.__uri;

              return (
                <li key={idx} className="nav-item">
                  <button
                    onClick={() => {
                      this.props.history.push(uriDic);
                    }}
                    className="navbar-nav-link button-link"
                    style={{
                      fontSize: '13px',
                      fontWeight: '500',
                      padding: '8px 16px',
                      borderRadius: '8px',
                      border: 'none',
                      background: 'transparent',
                      color: '#475569',
                      cursor: 'pointer',
                      transition: 'all 150ms ease',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '6px'
                    }}
                  >
                    <i className={PA.__className} style={{ fontSize: '13px' }}></i>
                    {PA.__name}
                  </button>
                </li>
              );
            }
            return null;
          })}
        </ul>
      );
    }

    return (
      <div className="navbar-collapse collapse" id="navbar-second">
        {__html}
      </div>
    );
  }

  render() {
    var loader = '';
    if (this.props.showLoader) {
      loader = (
        <div className="loading-container-app">
          <span className="loading-content-app" style={{
            background: '#6366F1',
            color: '#fff',
            borderRadius: '9999px',
            padding: '6px 16px',
            fontSize: '11px',
            fontWeight: '500',
            boxShadow: '0 4px 12px rgba(99, 102, 241, 0.3)',
            display: 'inline-flex',
            alignItems: 'center',
            gap: '6px'
          }}>
            <span style={{
              width: '14px',
              height: '14px',
              border: '2px solid rgba(255,255,255,0.3)',
              borderTopColor: '#fff',
              borderRadius: '50%',
              display: 'inline-block',
              animation: 'spin 0.8s linear infinite'
            }}></span>
            Loading...
          </span>
        </div>
      );
    }

    var __tabs = this.__render_tabs();
    return (
      <div className="virtual-body navbar-top-custom">
        {loader}
        <Header />
        <div className="page-content">
          <SideMenu />
          <div
            className="content-wrapper"
            style={{
              marginTop: '0',
              background: '#F1F5F9',
              minHeight: 'calc(100vh - 60px)'
            }}
          >
            {/* Page Header */}
            <div style={{
              background: '#fff',
              borderBottom: '1px solid #E2E8F0',
              padding: '14px 24px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <i className="icon-home2" style={{ fontSize: '13px', color: '#94A3B8' }}></i>
                <span style={{ fontSize: '13px', color: '#94A3B8' }}>/</span>
                <span style={{ fontSize: '13px', color: '#475569', fontWeight: '500' }}>{this.props.title}</span>
                {this.props.subTitle && <>
                  <span style={{ fontSize: '13px', color: '#94A3B8' }}>/</span>
                  <span style={{ fontSize: '13px', color: '#0F172A', fontWeight: '600' }}>{this.props.subTitle}</span>
                </>}
              </div>
            </div>

            {/* Content area */}
            <div className="content" style={{
              padding: '24px',
              animation: 'fadeIn 0.3s ease'
            }}>
              {this.state.content}
            </div>

            <Footer />
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Container);

Container.defaultProps = {
  showLoader: false,
  PageActions: [],
  tabs: []
};
